/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateAccountEntitlementsResult} from '../models/UpdateAccountEntitlementsResult';
import type {UpdateEntitlementsRelation} from '../models/UpdateEntitlementsRelation';

export interface BulkAssignAccountEntitlements$Request {
    updateEntitlementsRelation: UpdateEntitlementsRelation;
    reason?: string;
}

export interface BulkAssignAccountEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkAssignAccountEntitlementsRequest = createAction<PayloadData<void, BulkAssignAccountEntitlements$Request>>('BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__REQUEST');
export const bulkAssignAccountEntitlementsSuccess = createAction<PayloadData<string, BulkAssignAccountEntitlements$Request>>('BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__SUCCESS');
export const bulkAssignAccountEntitlementsFailure = createAction<PayloadData<Error, BulkAssignAccountEntitlements$Request, true>>('BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__FAILURE');

export const bulkAssignAccountEntitlementsActions = [
    bulkAssignAccountEntitlementsRequest,
    bulkAssignAccountEntitlementsSuccess,
    bulkAssignAccountEntitlementsFailure
] as const;

/**
 * @param {UpdateEntitlementsRelation} meta.updateEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkAssignAccountEntitlements = (meta: BulkAssignAccountEntitlements$Request, config?: BulkAssignAccountEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkAssignAccountEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignAccountEntitlementsProgress$Request {
    id: string;
}

export interface GetAssignAccountEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignAccountEntitlementsProgressRequest = createAction<PayloadData<void, GetAssignAccountEntitlementsProgress$Request>>('BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_ASSIGN_ACCOUNT_ENTITLEMENTS_PROGRESS__REQUEST');
export const getAssignAccountEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetAssignAccountEntitlementsProgress$Request>>('BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_ASSIGN_ACCOUNT_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getAssignAccountEntitlementsProgressFailure = createAction<PayloadData<Error, GetAssignAccountEntitlementsProgress$Request, true>>('BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_ASSIGN_ACCOUNT_ENTITLEMENTS_PROGRESS__FAILURE');

export const getAssignAccountEntitlementsProgressActions = [
    getAssignAccountEntitlementsProgressRequest,
    getAssignAccountEntitlementsProgressSuccess,
    getAssignAccountEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignAccountEntitlementsProgress = (meta: GetAssignAccountEntitlementsProgress$Request, config?: GetAssignAccountEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignAccountEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/entitlements/assign/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignAccountEntitlementsResult$Request {
    id: string;
}

export interface GetAssignAccountEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignAccountEntitlementsResultRequest = createAction<PayloadData<void, GetAssignAccountEntitlementsResult$Request>>('BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_ASSIGN_ACCOUNT_ENTITLEMENTS_RESULT__REQUEST');
export const getAssignAccountEntitlementsResultSuccess = createAction<PayloadData<UpdateAccountEntitlementsResult, GetAssignAccountEntitlementsResult$Request>>('BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_ASSIGN_ACCOUNT_ENTITLEMENTS_RESULT__SUCCESS');
export const getAssignAccountEntitlementsResultFailure = createAction<PayloadData<Error, GetAssignAccountEntitlementsResult$Request, true>>('BULK_ASSIGN_ACCOUNT_ENTITLEMENTS__GET_ASSIGN_ACCOUNT_ENTITLEMENTS_RESULT__FAILURE');

export const getAssignAccountEntitlementsResultActions = [
    getAssignAccountEntitlementsResultRequest,
    getAssignAccountEntitlementsResultSuccess,
    getAssignAccountEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignAccountEntitlementsResult = (meta: GetAssignAccountEntitlementsResult$Request, config?: GetAssignAccountEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignAccountEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/entitlements/assign`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

